import type { ReactElement } from 'react';
import React from 'react';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import messages from './messages';

const NewTabTooltipContainer = ({
    children,
    shouldOpenInANewTab,
    intl,
}: {
    children: ReactElement;
    shouldOpenInANewTab: boolean;
} & WrappedComponentProps): ReactElement =>
    shouldOpenInANewTab ? (
        <Tooltip content={intl.formatMessage(messages.newTabText)} position="mouse">
            {children}
        </Tooltip>
    ) : (
        <>{children}</>
    );

export default injectIntl(NewTabTooltipContainer);
